import React, { useCallback, useEffect, useReducer, useState } from "react";
import { useHistory } from "react-router-dom";
import { useVerticalNav } from "../../../Contexts/VerticalNavContext";
import { CustomDialog } from "../CustomDialog";
import { Box, Typography, Divider } from "@material-ui/core";
import { CustomAutocomplete } from "../CustomAutocomplete";
import { useTranslate } from "../../../Hooks";
import { useContactValidationContext } from "../../../Contexts/ContactValidationContext/ContactValidationContext";
import { useNewLayoutShared } from "../../../Contexts/NewLayoutSharedContext";
import {
  CityTypeIdEnum,
  CommunityTypeIdEnum,
  ContactClassIdEnum,
  DistrictTypeIdEnum,
  LanguageEnum,
  NationalityEnum,
  SalutationEnum,
} from "../../../Enums";
import { lookupItemsGetId, QuickAddContact } from "../../../Services";
import { OnAddnewContactRule } from "../../../Rule/ContactRule";
import { CustomButton } from "../CustomButton";

// Styles
import useStyles from "./styles";

const AddNewIndividualContactDialog = ({ onClose, onOpen }) => {
  const { addNewContact, setAlertBoxContent, setAddNewContact } =
    useVerticalNav();
  const styles = useStyles();
  const { translate } = useTranslate("HeaderView");
  const { translate: sharedTranslate } = useTranslate('SharedV2');
  const reducerAddContact = useCallback((state, action) => {
    if (action.id !== "edit") {
      return { ...state, [action.id]: action.value };
    } else {
      return action.value;
    }
  }, []);

  const { setData, setIsValidContact } = useContactValidationContext();
  const { showDialog } = useNewLayoutShared();

  const history = useHistory();
  const [isSubmit, setIsSubmit] = useState(false);
  const [selected, setSelected] = useReducer(reducerAddContact, {
    Title: null,
    AssignedTo: null,
    Nationality: null,
    Country: null,
    City: null,
    District: null,
    Community: null,
    Language: null,
    ContactClass: null,
  });
  const [formData, setFormData] = useReducer(reducerAddContact, {
    nationalities: [],
    languages: [],
    contactClasses: [],
    countries: [],
    cities: [],
    discrities: [],
    community: [0],
    salutation: [],
  });
  const [saveDto, setSaveDto] = useReducer(reducerAddContact, {
    contactsTypeId: 1,
    firstName: addNewContact?.contact?.firstName,
    lastName: addNewContact?.contact?.lastName,
    salutationId: "",
    emailAddress: [addNewContact?.contact?.email],
    phoneNumber: [addNewContact?.contact?.phone],
    nationalityId: "",
    countryId: 0,
    cityId: 0,
    districtId: 0,
    communityId: 0,
    postalZipCode: "",
    data_completed: 16,
    contactClassId: null,
    languageId: null,
  });

  const GetNationalities = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: NationalityEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "nationalities",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "nationalities",
        value: [],
      });
  }, []);

  const getAllLanguages = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: LanguageEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200))
      setFormData({
        id: "languages",
        value: res.map((item) => ({
          id: item?.lookupItemId,
          name: item?.lookupItemName,
          code: item?.lookupItemCode,
        })),
      });
    else
      setFormData({
        id: "languages",
        value: [],
      });
  }, []);

  const isDisabled = () => {
    return (
      !saveDto.nationalityId?.toString().trim() ||
      !saveDto.languageId ||
      !saveDto.contactClassId ||
      !saveDto.salutationId?.toString().trim() ||
      isSubmit
    );
  };

  const getAllContactClass = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: ContactClassIdEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200))
      setFormData({
        id: "contactClasses",
        value: res.map((item) => ({
          id: item?.lookupItemId,
          name: item?.lookupItemName,
          code: item?.lookupItemCode,
        })),
      });
    else
      setFormData({
        id: "contactClasses",
        value: [],
      });
  }, []);

  const GetCountries = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: NationalityEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "countries",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "countries",
        value: [],
      });
  }, []);

  const GetCities = useCallback(async (countryId) => {
    const res = await lookupItemsGetId({
      lookupTypeId: CityTypeIdEnum.lookupTypeId,
      lookupParentId: countryId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "cities",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "cities",
        value: [],
      });
  }, []);

  const GetDistrict = useCallback(async (cityId) => {
    const res = await lookupItemsGetId({
      lookupTypeId: DistrictTypeIdEnum.lookupTypeId,
      lookupParentId: cityId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "discrities",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "discrities",
        value: [],
      });
  }, []);

  const GetCommunity = useCallback(async (districtId) => {
    const res = await lookupItemsGetId({
      lookupTypeId: CommunityTypeIdEnum.lookupTypeId,
      lookupParentId: districtId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "community",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "community",
        value: [],
      });
  }, []);

  const GetSalutations = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: SalutationEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "salutation",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
        })),
      });
    } else
      setFormData({
        id: "salutation",
        value: [],
      });
  }, []);


  const restCounryRelatedChange = () => {
    setSelected({
      id: "City",
      value: null,
    });
    setSelected({
      id: "District",
      value: null,
    });
    setSelected({
      id: "Community",
      value: null,
    });
    setSaveDto({
      id: "cityId",
      value: null,
    });
    setSaveDto({
      id: "districtId",
      value: null,
    });
    setSaveDto({
      id: "communityId",
      value: null,
    });
  };

  const restCityRelatedChange = () => {
    setSelected({
      id: "District",
      value: null,
    });
    setSelected({
      id: "Community",
      value: null,
    });
    setSaveDto({
      id: "districtId",
      value: null,
    });
    setSaveDto({
      id: "communityId",
      value: null,
    });
  };

  const restDistrictRelatedChange = () => {
    setSelected({
      id: "Community",
      value: null,
    });
    setSaveDto({
      id: "communityId",
      value: null,
    });
  };
  // const saveAndCompleteHandler = () => {
  //   onClose();

  //   setAddNewContact((prev) => ({
  //     ...prev,
  //     contact: { ...prev.contact, selected },
  //   }));

  //   history.push("/home/Contacts-CRM/add?formType=1");
  // };
  const AddContactHandler = async () => {
    let result = null;
    try {
      setIsSubmit(true);
      result = await QuickAddContact({
        ...saveDto,
        phoneNumber: [addNewContact?.contact?.phone],
        emailAddress: [addNewContact?.contact?.email],
      });
      if (!(result && result.data)) {
        // setAlertBoxContent({
        //   display: true,
        //   variant: "success",
        //   title: "Contact added successfully!",
        //   onClose: () => {
        //     setAlertBoxContent(null);
        //   },
        // });
        onClose();

        if (result?.contactId) {
          showDialog(sharedTranslate("contact-successfully"), {
            name: `${addNewContact?.contact?.firstName}  ${addNewContact?.contact?.lastName}`,
            id: result?.contactId,
          });
        }
      } else {
        setAlertBoxContent({
          display: true,
          variant: "error",
          title: "Something went wrong!",
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
      }
    } catch (error) {
      console.error("some thing wrong !", error);
    } finally {
      setIsSubmit(false);

      setData(addNewContact?.contact);

      setAddNewContact((prev) => ({
        ...prev,
        contact: { ...prev.contact, selected },
        addContactModalOpened: false,
      }));

      if (addNewContact?.isFormBuilderContact) {
        OnAddnewContactRule(
          addNewContact?.item,
          addNewContact?.itemList,
          addNewContact?.setData,
          addNewContact?.contact
        );

        if (addNewContact?.setInputValue) {
          addNewContact.setInputValue(
            addNewContact?.contact?.firstName +
              " " +
              addNewContact?.contact?.lastName
          );
        }

        if (addNewContact?.setNewValue) {
            addNewContact.setNewValue({
            name: `${addNewContact?.contact?.firstName} ${addNewContact?.contact?.lastName}`,
            id: result?.contactId,
            type: result?.firstName ? 1 : 2,
            email_address: result?.email,
            mobile: result?.mobile,
          });
        }

        if (addNewContact?.setData) {
          addNewContact.setData(addNewContact?.item.field.id, {
            name: `${addNewContact?.contact?.firstName} ${addNewContact?.contact?.lastName}`,
            id: result?.contactId,
            type: result?.firstName ? 1 : 2,
            email_address: result?.email,
            mobile: result?.mobile,
          });
        }
      }

      onClose();
    }
  };

  useEffect(() => {
    GetNationalities("");
    getAllLanguages();
    getAllContactClass();
    GetCountries();
    GetSalutations();
  }, [
    GetNationalities,
    getAllLanguages,
    getAllContactClass,
    GetCountries,
    GetSalutations,
  ]);

  return (
    <>
      <CustomDialog
        open={onOpen}
        onClose={onClose}
        title={translate("Add-new-contacts")}
        subtitle={translate(
          "Create-a-new-contact-entry-specifying-whether-it-is-an-individual-or-corporate-entity-to-categorize-and-manage-contacts-effectively"
        )}
        width={"1024px"}
        confirmText={translate("Add-contact")}
        onConfirm={() => {
          if (addNewContact?.shouldOpenAddPage) {
            setIsSubmit(false);

            setData(addNewContact?.contact);

            setIsValidContact(true);
            onClose();

            history.push(
              `/home/Contacts-CRM/add?formType=${
                addNewContact?.contact?.companyName ? 2 : 1
              }`
            );
          } else {
            AddContactHandler();
          }
        }}
        contentDialogClass={styles.containerContentDialog}
        isDisabled={isDisabled()}
        content={
          <Box className={styles.wrapperAddNewContactDialog}>
            <Box className={styles.containerContactInfo}>
              <Box className={styles.containerInfoItem}>
                <Typography className={styles.InfoTitle}>
                  {translate("First-name")}
                </Typography>
                <Typography className={styles.InfoValue}>
                  {addNewContact?.contact?.firstName}
                </Typography>
              </Box>
              <Box className={styles.containerInfoItem}>
                <Typography className={styles.InfoTitle}>
                  {translate("Last-name")}
                </Typography>
                <Typography className={styles.InfoValue}>
                  {addNewContact?.contact?.lastName}
                </Typography>
              </Box>
              <Box className={styles.containerInfoItem}>
                <Typography className={styles.InfoTitle}>
                  {translate("Phone-number")}
                </Typography>
                <Typography className={styles.InfoValue}>
                  {addNewContact?.contact?.phone}
                </Typography>
              </Box>
              <Box className={styles.containerInfoItem}>
                <Typography className={styles.InfoTitle}>
                  {translate("Email")}
                </Typography>
                <Typography className={styles.InfoValue}>
                  {addNewContact?.contact?.email}
                </Typography>
              </Box>
            </Box>
            <Box className={styles.containerContactFiled}>
              <Box className={styles.continerFiledItem}>
                <Typography className={styles.TitleFiledItem}>
                  {translate("Salutation")}*
                </Typography>
                <CustomAutocomplete
                  options={
                    formData.salutation && formData.salutation.length > 0
                      ? formData.salutation
                      : []
                  }
                  value={selected?.Title || null}
                  placeholder={`Select value`}
                  onChange={(e, value) => {
                    setSelected({
                      id: "Title",
                      value: value,
                    });
                    setSaveDto({
                      id: "salutationId",
                      value: value?.id,
                    });
                  }}
                  getOptionLabel={(option) => (option && option.name) || ""}
                  getOptionValue={(option) => (option && option.id) || ""}
                />
              </Box>
              <Box className={styles.continerFiledItem}>
                <Typography className={styles.TitleFiledItem}>
                  {translate("Nationality")}*
                </Typography>
                <CustomAutocomplete
                  options={
                    formData.nationalities && formData.nationalities.length > 0
                      ? formData.nationalities
                      : []
                  }
                  value={selected?.Nationality || null}
                  placeholder={`Select value`}
                  onChange={(e, value) => {
                    setSelected({
                      id: "Nationality",
                      value: value,
                    });
                    setSaveDto({
                      id: "nationalityId",
                      value: value?.id,
                    });
                  }}
                  getOptionLabel={(option) => (option && option.name) || ""}
                  getOptionValue={(option) => (option && option.id) || ""}
                />
              </Box>
              <Divider className={styles.divider}></Divider>
              <Box className={styles.continerFiledItem}>
                <Typography className={styles.TitleFiledItem}>
                  {translate("Languages")}*
                </Typography>
                <CustomAutocomplete
                  options={
                    formData.languages && formData.languages.length > 0
                      ? formData.languages
                      : []
                  }
                  value={selected?.Language || null}
                  placeholder={`Select value`}
                  onChange={(e, value) => {
                    setSelected({
                      id: "Language",
                      value: value,
                    });
                    setSaveDto({
                      id: "languageId",
                      value: value?.id,
                    });
                  }}
                  getOptionLabel={(option) => (option && option.name) || ""}
                  getOptionValue={(option) => (option && option.id) || ""}
                />
              </Box>
              <Divider className={styles.divider}></Divider>
              <Box className={styles.continerFiledItem}>
                <Typography className={styles.TitleFiledItem}>
                  {translate("Contact-class")}*
                </Typography>
                <CustomAutocomplete
                  options={
                    formData.contactClasses &&
                    formData.contactClasses.length > 0
                      ? formData.contactClasses
                      : []
                  }
                  placeholder={`Select value`}
                  value={selected?.ContactClass || null}
                  onChange={(e, value) => {
                    setSelected({
                      id: "ContactClass",
                      value: value,
                    });
                    setSaveDto({
                      id: "contactClassId",
                      value: value?.id,
                    });
                  }}
                  getOptionLabel={(option) => (option && option?.name) || ""}
                  getOptionValue={(option) => (option && option?.id) || ""}
                />
              </Box>
              <Divider className={styles.divider}></Divider>
              <Box className={styles.continerFiledItem}>
                <Typography className={styles.TitleFiledItem}>
                  {translate("Country")}
                </Typography>
                <CustomAutocomplete
                  options={
                    formData?.countries && formData.countries.length > 0
                      ? formData?.countries
                      : []
                  }
                  value={selected?.Country || null}
                  placeholder={`Select value`}
                  onChange={(e, value) => {
                    setSelected({
                      id: "Country",
                      value: value,
                    });
                    setSaveDto({
                      id: "countryId",
                      value: value?.id,
                    });
                    restCounryRelatedChange();

                    if (value) GetCities(value?.id);
                    else {
                      setFormData({
                        id: "cities",
                        value: [],
                      });
                      restCounryRelatedChange();
                    }
                  }}
                  getOptionLabel={(option) => (option && option?.name) || ""}
                  getOptionValue={(option) => (option && option?.id) || ""}
                />
              </Box>
              <Divider className={styles.divider}></Divider>
              <Box className={styles.continerFiledItem}>
                <Typography className={styles.TitleFiledItem}>
                  {translate("City")}
                </Typography>
                <CustomAutocomplete
                  options={
                    formData.cities && formData.cities.length > 0
                      ? formData.cities
                      : []
                  }
                  value={selected?.City || null}
                  placeholder={`Select value`}
                  onChange={(e, value) => {
                    setSelected({
                      id: "City",
                      value: value,
                    });
                    setSaveDto({
                      id: "cityId",
                      value: value?.id,
                    });
                    restCityRelatedChange();
                    if (value) GetDistrict(value?.id);
                    else {
                      setFormData({
                        id: "discrities",
                        value: [],
                      });
                      restCityRelatedChange();
                    }
                  }}
                  getOptionLabel={(option) => (option && option.name) || ""}
                  getOptionValue={(option) => (option && option.id) || ""}
                />
              </Box>
              <Divider className={styles.divider}></Divider>
              <Box className={styles.continerFiledItem}>
                <Typography className={styles.TitleFiledItem}>
                  {translate("District")}
                </Typography>
                <CustomAutocomplete
                  options={
                    formData.discrities && formData.discrities.length > 0
                      ? formData.discrities
                      : []
                  }
                  value={selected?.District || null}
                  placeholder={`Select value`}
                  onChange={(e, value) => {
                    setSelected({
                      id: "District",
                      value: value,
                    });
                    setSaveDto({
                      id: "districtId",
                      value: value?.id,
                    });
                    restDistrictRelatedChange();
                    if (value) GetCommunity(value?.id);
                    else {
                      setFormData({
                        id: "community",
                        value: [],
                      });
                      restDistrictRelatedChange();
                    }
                  }}
                  getOptionLabel={(option) => (option && option.name) || ""}
                  getOptionValue={(option) => (option && option.id) || ""}
                />
              </Box>
              <Divider className={styles.divider}></Divider>
              <Box className={styles.continerFiledItem}>
                <Typography className={styles.TitleFiledItem}>
                  {translate("Community")}
                </Typography>
                <CustomAutocomplete
                  options={
                    formData.community && formData.community.length > 0
                      ? formData.community
                      : []
                  }
                  value={selected?.Community || null}
                  placeholder={`Select value`}
                  onChange={(e, value) => {
                    setSelected({
                      id: "Community",
                      value: value,
                    });
                    setSaveDto({
                      id: "communityId",
                      value: value?.id,
                    });
                  }}
                  getOptionLabel={(option) => (option && option.name) || ""}
                  getOptionValue={(option) => (option && option.id) || ""}
                />
              </Box>
            </Box>
          </Box>
        }
        moreAction={
          <CustomButton
            boxShadow="none"
            size="lg"
            variant="text"
            color="tertiaryGray"
            isDisabled={isDisabled()}
            // onClick={() => {
            //   saveAndCompleteHandler();
            // }}
            style={{ marginInlineEnd: "auto" }}
          >
            Save & Complete Details
          </CustomButton>
        }
      />
    </>
  );
};
export default AddNewIndividualContactDialog;
